import React from 'react';
import {
  Button,
  InlineNotification,
  CodeSnippet
} from 'carbon-components-react';

const PermalinkSection: React.FC<Props> = ({ url, onClose }) => {
  return (
    <div className="permalink-container">
      <InlineNotification
        kind="info"
        title="Anyone with this link can view the plans"
        lowContrast={true}
        hideCloseButton={true}
      />
      <div className="permalink-content">
        <div className="permalink-body">
          <div className="permalink-title">Share link</div>
          <CodeSnippet type="multi" wrapText={true}>
            {url}
          </CodeSnippet>
          <div className="permalink-help-text">
            Copy and share a permanent link to this enquiry
          </div>
        </div>
        <div className="permalink-footer">
          <Button kind="tertiary" onClick={() => onClose()}>
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};

type Props = {
  url: string;
  onClose: Function;
};

export default React.memo(PermalinkSection);
